/**
 * @description 物料管理API
 * @author 赵银
 */
import request from "@/utils/request";
/**
 * @description 类别
 */

// 获取数据
export function queryCategoryList(data) {
  return request({
    url: "/materialCategory/page",
    method: "post",
    data,
  });
}

// 通过id获取单条数据
export function queryCategoryById(id) {
  return request({
    url: `/materialCategory/${id}`,
    method: "get",
  });
}

// 新增数据
export function insertCategory(data) {
  return request({
    url: "/materialCategory/save",
    method: "post",
    data,
  });
}

// 修改数据
export function updateCategory(data) {
  return request({
    url: "/materialCategory/update",
    method: "post",
    data,
  });
}

// 删除数据
export function deleteCategoryById(id) {
  return request({
    url: `/materialCategory/delete/${id}`,
    method: "delete",
  });
}

// excel数据导入
export function uploadExcelData(data) {
  return request({
    url: "/materialCategory/import",
    method: "post",
    data,
  });
}

// 查询树形数据
export function queryCategoryTree() {
  return request({
    url: "/materialCategory/tree",
    method: "get",
  });
}

/**
 * @description 物料管理API
 */

// 物料管理表格
export function queryMaterielList(data) {
  return request({
    url: "/material/table",
    method: "post",
    data,
  });
}

// 通过id查询详情
export function queryMaterielById(id) {
  return request({
    url: `/material/${id}`,
    method: "get",
  });
}

// 新增物料
export function insertMateriel(data) {
  return request({
    url: "/material/save",
    method: "post",
    data,
  });
}

// 编辑物料
export function updateMateriel(data) {
  return request({
    url: "/material/update",
    method: "post",
    data,
  });
}

// 删除物料
export function deleteMateriel(id) {
  return request({
    url: `/material/${id}`,
    method: "delete",
  });
}

// 查询字典数据
export function queryDictList() {
  return request({
    url: "/material/dict",
    method: "get",
  });
}

// 数据导入
export function importMateriel(data) {
  return request({
    url: "/material/import",
    method: "post",
    data,
  });
}

// 物料类别导入
export function importmaterialCategory(data) {
  return request({
    url: "/materialCategory/import",
    method: "post",
    data,
  });
}
